import axios from 'axios'
import ayalconfig from "../ayalconfig";

let db = null;
const endPoint = ayalconfig.logger.loggerEndPoint;
const webDbConfig = ayalconfig.websqlDb;

class WebLog {

    initLog(){
        try {
            db = openDatabase(webDbConfig.dbName, webDbConfig.version, webDbConfig.dbDisplayName, webDbConfig.estimatedSize);
        }catch (e){
            console.log("Error opening openDatabase")
        }
        if (db){
            db.transaction(function (tx) {
                tx.executeSql("CREATE TABLE IF NOT EXISTS logger (id integer primary key, timestamp text, status text, message text, isSynced boolean)");
            });
            if (navigator.onLine){
                webLog.select();
            }
            webLog.clearLog();
        }
    }

    insert(timestamp, status, message, isSynced){
        if (db){
            db.transaction(function (tx) {
                tx.executeSql("INSERT INTO logger (timestamp, status, message, isSynced) VALUES (?,?,?,?)", [timestamp, status, message, isSynced]);
            });
        }
    }

    select(){
        if (db){
            db.transaction(function (tx) {
                tx.executeSql("SELECT id, timestamp, status, message FROM logger  WHERE isSynced=? ORDER BY timestamp ASC", [false], function (tx, results) {
                    var len = results.rows.length, i;
                    if (len > 0) {
                        let logs = [];
                        for (i = 0; i < len; i++) {
                            let item = results.rows.item(i);
                            logs.push(item);
                            tx.executeSql('UPDATE logger SET isSynced=? WHERE id=?', [true, results.rows.item(i).id]);
                        }
                        webLog.syncLog(logs);
                    }
                });
            });
        }
    }

    getLogs(updateLogs){
        if (!db){
            return
        }
        db.transaction(function (tx) {
            tx.executeSql("SELECT timestamp, status, message FROM logger ORDER BY timestamp DESC", [], function (tx, results) {
                var len = results.rows.length, i;
                let logs = [];
                if (len > 0) {
                    for (i = 0; i < len; i++) {
                        let item = results.rows.item(i);
                        logs.push(item);
                    }
                }
                updateLogs(logs);
            });
        });
    }

    syncLog(logs){
        return axios({
            method: "post",
            url: `${endPoint}`,
            data: logs,
        }).then(function (response) {
            if (!response.data.success){
                db.transaction(function (tx) {
                    for (var i = 0; i < logs.length; i++) {
                        tx.executeSql('UPDATE logger SET isSynced=? WHERE id=?', [false, logs[i].id]);
                    }
                });
            }
        }).catch(function (error) {
            console.log("Failed to save logs");
        });
    }

    clearLog(){
        let days = webDbConfig.dbClearDays;
        let previousDate = new Date(new Date().getTime() - (days * 24 * 60 * 60 * 1000));
        db.transaction(function (tx) {
            tx.executeSql("DELETE FROM logger WHERE isSynced=? and timestamp <= ?", [true, webLog.formatDate(previousDate)]);
        });
    }

    formatDate(date){
        let formattedDate = '';
        try {
            formattedDate = new Date(date).toLocaleString("zh-TW",
                {timeZone: "Asia/Jerusalem", year:'numeric', month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit", second:"2-digit", hour12:false});

        }catch (e) {
            formattedDate = date.toISOString();
        }
        return formattedDate
    }
}
const webLog = new WebLog();
export default webLog